import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import {Container,Row,Col,Button} from 'react-bootstrap';
import IconBox from '../../Presale/IconBox'



const Banner = () => {


  return (
    <>
        <section className='presale_banner'>
                        <Container>
                            <Row className='justify-content-center' style={{ minHeight: "430px" }} >
                                <Col lg={10} className='text-center'>
                                    <div className="banner-content">
                                        <h1 className="text-uppercase mb-3">
                                            <span className="text-wrapper">Play it, Live it, Earn it</span>
                                        </h1>
                                        <p className='text-white'>Our ico presents an exclusive opportunity to join a revolutionary financial movement. It transcends being a mere cryptocurrency project. By owning INFI tokens, you become an integral part of Inverted Investment, entitling you to receive monthly payments from our 60% profit in USDT and BTC.</p>
                                        <a href='https://launchpad.infimultichain.com/whitepaper' target="_blank"rel="noreferrer noopener" className="btn btn-primary fs-5 text-black fw-bold">Whitepaper</a>
                                    <IconBox />
                                    </div>
                                </Col>
                            </Row>
                        </Container>
        </section>
    </>
  );
}

export default Banner
